import axios from '../axios-auth'

export const systemSerializeService = {
    getSystemSerializeList,
    saveSystemSerialize,
    getSystemSerializeDetail,
    getAllSystemSerializeType
};

function getAllSystemSerializeType() {
    return axios.get("/auth/system-serialize-types/");
}

function getSystemSerializeList(searchParams, page, size ,sortedBy) {
    if(!page){
        page = 0;
    }
    else{
        page -= 1;
    }
    if(!size){
        size = 50;
    }
    let url = '/auth/system-serializes?page='+page+'&size='+size+'&sort='+sortedBy;
    if (searchParams.prefix) {
        url += '&prefix=' + searchParams.prefix;
    }
    if (searchParams.type) {
        url += '&type=' + searchParams.type;
    }
    if (searchParams.status) {
        url += '&status=' + searchParams.status;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.warehouseId) {
        url += '&warehouseId=' + searchParams.warehouseId;
    }
    return axios.get(url);
}

function saveSystemSerialize(systemSerialize) {
    if (systemSerialize.id) {
        //edit
        return axios.put("/auth/system-serialize", systemSerialize);
      } else {
        // create new
        return axios.post("/auth/system-serialize", systemSerialize);
      }
}

function getSystemSerializeDetail(id) {
    return axios.get("/auth/system-serialize/" + id);
}